import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { TextField, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
    },
    TextField: {
        maxWidth: '376px',
        height: 74,
        '@media screen and (max-width: 768.98px)': {
            maxWidth: '330px',
        }
    },
    ButtonBase: {
      padding: 0,
      margin: 0,
      width: isMobile ? 139 : 153,
      minWidth: 'initial',
    },
    linkStyle: {
      width: isMobile ? 139 : 153,
      margin: '0 10px 0 0',
      '&:$last-child': {
        margin: 0
      }
    },
    form: {
      width: '100%',
    },
    buttonContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',
    },
  });

const SwitcherForm = ({
    values,
    isValid,
    handleChange,
    handleSubmit,
    handleBlur,
    touched,
    errors,
    handleClose,
    hideForm,
}) => {

    const classes = useStyles()

    const [valuesPass, setValuesPass] = useState({
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValuesPass({
            showPassword: !valuesPass.showPassword
        });
    };

    return (
        <form className={classes.form}>
        
            {!hideForm &&
                <>
                    <TextField
                        label="Correo"
                        type="email"
                        id="email"
                        variant="outlined"
                        classes={{ root: classes.TextField }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                        helperText={touched.email && errors.email ? errors.email : ''}
                        error={touched.email && errors.email ? true : false}
                    />

                    <TextField
                        id="outlined-adornment-password"
                        variant="outlined"
                        type={valuesPass.showPassword ? 'text' : 'password'}
                        label="Contraseña"
                        name="password"
                        classes={{ root: classes.TextField }}
                        value={values.password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        helperText={
                            touched.password && errors.password ? errors.password : ''
                        }
                        error={touched.password && errors.password ? true : false}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        classes={{
                                            root: classes.colorGrayIcon
                                        }}
                                    >
                                        {valuesPass.showPassword ? 
                                            <VisibilityOff /> :
                                            <Visibility />
                                        }
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </>
            }

            <div className={classes.buttonContainer}>
                <ButtonBase
                    type="button"
                    onClick={handleClose}
                    variant="primary"
                    linkStyle={classes.linkStyle}
                    className={classes.ButtonBase}
                >
                    Cancelar
                </ButtonBase>

                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primarySolidOutlined"
                    linkStyle={classes.linkStyle}
                    className={classes.ButtonBase}
                    style={{ marginRight: 16}}
                    disabled={ hideForm ? false : !isValid}
                >
                    Sí, continuar
                </ButtonBase>
            </div>
        </form>
    )
}

export default SwitcherForm;
